import { computed } from 'vue'
import { useUserStore } from '@/stores'

export default () => {
  return {
    initials: computed(() => {
      const { isAuthenticated, name, surname } = useUserStore()

      if (isAuthenticated) {
        return name || surname
          ? `${name.length > 0 ? name[0] : ''}${surname.length > 0 ? surname[0] : ''}`
          : null
      } else {
        return null
      }
    }),

    isTotpMfaEnabled: computed(() => useUserStore().mfaMethods.includes('totp')),
    isEmailMfaEnabled: computed(() => useUserStore().mfaMethods.includes('email')),
    mfaEnabled: computed(() => useUserStore().mfaMethods.length > 0),
    // GET api/user eager-loads Spatie roles, so each entry carries its name.
    isSuperAdmin: computed(() => useUserStore().roles?.some(({ name }) => name === 'Super Admin') ?? false)
  }
}
